import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetRefuseLeadSettingsRequest = App.Http.Requests.RefuseLeadSettings.GetRefuseLeadSettingsRequest;
import GetRefuseLeadSettingsResponse = App.Http.Responses.RefuseLeadSettings.GetRefuseLeadSettingsResponse;
import GetRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.GetRefuseLeadSettingRequest;
import GetRefuseLeadSettingResponse = App.Http.Responses.RefuseLeadSettings.GetRefuseLeadSettingResponse;
import StoreRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.StoreRefuseLeadSettingRequest;
import UpdateRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.UpdateRefuseLeadSettingRequest;

class RefuseLeadSettingsApi extends TenantBaseApi {
    /**
     * Get list of refuse lead settings
     *
     * - Request: GetRefuseLeadSettingsRequest
     * - Response: GetRefuseLeadSettingsResponse
     */
    async index(offerId: string, request: GetRefuseLeadSettingsRequest): Promise<GetRefuseLeadSettingsResponse> {
        return await this.get<GetRefuseLeadSettingsResponse, GetRefuseLeadSettingsRequest>(
            `/offers/${offerId}/refuse-lead-settings`,
            {
                params: request,
            }
        );
    }

    /**
     * Get specific refuse lead setting
     *
     * - Request: GetRefuseLeadSettingRequest
     * - Response: GetRefuseLeadSettingResponse
     */
    async show(offerId: string, refuseLeadSettingId: string, request: GetRefuseLeadSettingRequest): Promise<GetRefuseLeadSettingResponse> {
        return await this.get<GetRefuseLeadSettingResponse, GetRefuseLeadSettingRequest>(
            `/offers/${offerId}/refuse-lead-settings/${refuseLeadSettingId}`,
            {
                params: request,
            }
        );
    }

    /**
     * Store refuse lead setting
     *
     * - Request: StoreRefuseLeadSettingRequest
     * - Response: GetRefuseLeadSettingResponse
     */
    async store(offerId: string, request: StoreRefuseLeadSettingRequest): Promise<GetRefuseLeadSettingResponse> {
        return await this.post<GetRefuseLeadSettingResponse, StoreRefuseLeadSettingRequest>(
            `/offers/${offerId}/refuse-lead-settings`,
            request
        );
    }

    /**
     * Update refuse lead setting
     *
     * - Request: UpdateRefuseLeadSettingRequest
     * - Response: GetRefuseLeadSettingResponse
     */
    async update(offerId: string, refuseLeadSettingId: string, request: UpdateRefuseLeadSettingRequest): Promise<GetRefuseLeadSettingResponse> {
        return await this.put<GetRefuseLeadSettingResponse, UpdateRefuseLeadSettingRequest>(
            `/offers/${offerId}/refuse-lead-settings/${refuseLeadSettingId}`,
            request
        );
    }

    /**
     * Delete refuse lead setting
     *
     * - Response: void
     */
    async destroy(offerId: string, refuseLeadSettingId: string): Promise<void> {
        return await this.delete(`/offers/${offerId}/refuse-lead-settings/${refuseLeadSettingId}`);
    }
}

export const refuseLeadSettingsApi = new RefuseLeadSettingsApi();
